export default __webpack_public_path__ + "static/media/Nav_man_1024.1031d7d3.png";